import type { PiggyBankOsraConfigInterface } from '@/map-phaser-new/interfaces'

export const piggyBankOsra: PiggyBankOsraConfigInterface = {
  textureKey: 'piggy_bank_osra_image',
  positionX: 2583,
  positionY: 939,
  notificationX: 2595,
  notificationY: 825,
  depth: 3,
  origin: 0.5,
  inputConfig: {
    useHandCursor: true,
  },
  outlineConfig: {
    textureKey: 'piggy_bank_osra_image_outline',
    depth: 3,
  },
}
